import { useEffect, useRef, useCallback } from "react";
import useUserData from "./useUserData";
import axios from "axios";

const CACHE_INVOKER_KEY = "cc_cache_invoker_last_run_v1";
const DAY_MS = 24 * 60 * 60 * 1000;

function cacheInvokerRanRecently(email) {
  try {
    const saved = JSON.parse(localStorage.getItem(CACHE_INVOKER_KEY) || "{}");
    const at = Number(saved[String(email || "")] || 0);
    return at > 0 && Date.now() - at < DAY_MS;
  } catch (error) {
    return false;
  }
}

function rememberCacheInvokerRun(email) {
  try {
    const saved = JSON.parse(localStorage.getItem(CACHE_INVOKER_KEY) || "{}");
    saved[String(email || "")] = Date.now();
    localStorage.setItem(CACHE_INVOKER_KEY, JSON.stringify(saved));
  } catch (error) {
    return;
  }
}

const useActiveTabInterval = (intervalMs = 60000, enabled = true) => {
  const intervalRef = useRef(null);
  // const lastActivityRef = useRef(Date.now());
  // const isActiveRef = useRef(true);
  const { email, username } = useUserData();

  // Memoized internal callback function
  const internalCallback = useCallback(async () => {
    if (enabled && email && !cacheInvokerRanRecently(email)) {
      rememberCacheInvokerRun(email);
      await axios
        .post(
          "https://a1d8bke60b.execute-api.ap-southeast-2.amazonaws.com/dev/api",
          {
            platform_mode: "cache_invoker",
            request_type: "trigger_all_processes",
            user: username,
            email,
          },
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [email, username, enabled]);

  // // Activity tracker to update last activity time
  // const updateActivity = useCallback(() => {
  //   lastActivityRef.current = Date.now();
  //   isActiveRef.current = true;
  // }, []);

  // // Check if user is still active (within last 5 minutes)
  // const isUserActive = useCallback(() => {
  //   const now = Date.now();
  //   const timeSinceLastActivity = now - lastActivityRef.current;
  //   return timeSinceLastActivity < 300000; // 5 minutes
  // }, []);

  // Handle visibility change
  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      // Clear interval when tab becomes hidden
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    } else {
      // Start interval when tab becomes visible
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      intervalRef.current = setInterval(() => {
        if (!document.hidden) {
          internalCallback();
        }
      }, intervalMs);
    }
  }, [intervalMs, internalCallback]);

  // // Start the interval (original complex logic)
  // const startInterval = useCallback(() => {
  //   if (intervalRef.current) {
  //     clearInterval(intervalRef.current);
  //   }

  //   intervalRef.current = setInterval(() => {
  //     if (!document.hidden && isActiveRef.current) {
  //       if (isUserActive()) {
  //         internalCallback();
  //       } else {
  //         // Stop interval if user is inactive for too long
  //         isActiveRef.current = false;
  //         if (intervalRef.current) {
  //           clearInterval(intervalRef.current);
  //           intervalRef.current = null;
  //         }
  //       }
  //     }
  //   }, intervalMs);
  // }, [intervalMs, isUserActive, internalCallback]);

  useEffect(() => {
    if (!enabled) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Call the callback immediately on first render
    internalCallback();

    // Start interval if tab is visible
    if (!document.hidden) {
      intervalRef.current = setInterval(() => {
        if (!document.hidden) {
          internalCallback();
        }
      }, intervalMs);
    }

    // // Optimized activity event listeners - removed high-frequency events (original logic)
    // const activityEvents = ["mousedown", "keypress", "touchstart", "click"];

    // // Add event listeners for user activity
    // activityEvents.forEach((event) => {
    //   document.addEventListener(event, updateActivity, {
    //     passive: true,
    //     capture: true,
    //   });
    // });

    // Add visibility change listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup function
    return () => {
      // // Remove activity event listeners (original logic)
      // activityEvents.forEach((event) => {
      //   document.removeEventListener(event, updateActivity, {
      //     passive: true,
      //     capture: true,
      //   });
      // });

      // Remove visibility change listener
      document.removeEventListener("visibilitychange", handleVisibilityChange);

      // Clear interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [intervalMs, internalCallback, handleVisibilityChange, enabled]);

  // Return a function to manually trigger the callback
  return {
    triggerCallback: () => internalCallback(),
    // isActive: () => isActiveRef.current && !document.hidden && isUserActive(),
  };
};

export default useActiveTabInterval;
